export enum UserType { owner, realtor, servicer }